(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
	document.querySelector(".header").classList.add("header--black");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-banner"]) return;
  try {
    
	document.querySelector(".header").classList.add("header--black");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-default-template"]) return;
  try {
    
	document.querySelector(".header").classList.add("header--black");

  } catch(e) { console.error(e); }
})();
})();
